import { Variants } from 'framer-motion';

export const fadeInFromBottomAnimation: (delay?: number, duration?: number) => Variants = (
  delay = 0,
  duration = 0.3,
) => ({
  hidden: { opacity: 0, y: '5em' },
  show: { opacity: 1, y: 0, transition: { type: 'tween', delay, duration } },
});
